import React from "react";

import { Route_custom as RouteCustom } from "../config";
import "./App.css";

function App() {
  return <RouteCustom />;
}

export default App;
